import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) => ({
  infoIcon: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(-1),
    cursor: 'pointer',
  },
  defaultIcon: {
    height: 14,
    width: 14,
  },
}));
